export default "__VITE_PUBLIC_ASSET__cf614d19__"